import axios from "axios";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const FileUploadIcon_Doc = `${CDN_URL}billing/Billing_Download_INV_Doc.svg`;
const FileUploadIcon_Jpg = `${CDN_URL}billing/Billing_Download_INV_JPG.svg`;
const FileUploadIcon_Png = `${CDN_URL}billing/Billing_Download_INV_PNG.svg`;
const FileUploadIcon_Pdf = `${CDN_URL}billing/Billing_Download_INV_PDF.svg`;
const FileUploadIcon_General = `${CDN_URL}common/Icon-Download Generic.svg`;

const STATIC_EXCLUSION_LIST = "EXE,COM,BAT,CMD,MSI,VB,VBS,WS,WSF,SCF,SCR,PIF";
const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/support`;
//const BASE_URL = 'http://localhost:8085';
const config = {
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

export class AttachmentApi {
  static sendAttachment(file, type = "image/jpeg") {
    const fileToUpload = file && file.file ? file.file : file;
    const url = `${BASE_URL}/attachment/`;
    const formData = new FormData();

    const config = {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const view = new Uint8Array(fileToUpload);
    for (let i = 0; i < fileToUpload.length; i++) {
      view[i] = fileToUpload.charCodeAt(i);
    }

    // Create Blob from ArrayBuffer
    const blob = new Blob([view], { type });
    formData.append("file", blob);

    return axios.post(url, formData, config);
  }
  static sendAttachmentBlob(blob) {
    const url = `${BASE_URL}/attachment/`;

    const formData = new FormData();

    const config = {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    formData.append("file", blob);

    return axios.post(url, formData, config);
  }

  static formatBytes(bytes, decimals = 0) {
    if (bytes === 0) return "0 bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["bytes", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
  }
  static getFileStatusFromML(id) {
    const url = `${BASE_URL}/attachment/status/${id}`;

    return axios.get(url, config);
  }

  static getScannedFile(id) {
    const url = `${BASE_URL}/file/${id}`;

    return axios.get(url, config);
  }

  static isValidAttachmentType(attachment) {
    const exclusionList = process.env.REACT_APP_FILE_ATTACHMENT_EXCLUSIONS
      ? process.env.REACT_APP_FILE_ATTACHMENT_EXCLUSIONS
      : STATIC_EXCLUSION_LIST;

    const nonAcceptedTypes = exclusionList.split(",");
    let attachmentType = attachment.type.split("/")[1];
    let isValid = true;

    /** IE and Edge do not recognize certain file formats and
     * will not populate the attachment.type param
     */
    if (attachment.type === "" || attachmentType === undefined) {
      attachmentType = this.extractFileExtension(attachment.filename);
    }
    if (!attachmentType) return false;

    nonAcceptedTypes.forEach((invalidType) => {
      if (invalidType.toLowerCase() === attachmentType.toLowerCase()) {
        isValid = false;
      }
    });

    return isValid;
  }

  static getFileTypeIcon(filename) {
    const extension = this.extractFileExtension(filename);

    switch (extension) {
      case "pdf":
      case "PDF":
        return FileUploadIcon_Pdf;
      case "png":
      case "PNG":
        return FileUploadIcon_Png;
      case "jpg":
      case "JPG":
        return FileUploadIcon_Jpg;
      case "doc":
      case "DOC":
      case "docx":
        return FileUploadIcon_Doc;
      default:
        return FileUploadIcon_General;
    }
  }

  static extractFileExtension(filename) {
    const extensionRegex = /\.(\w+)$/;
    const matches = filename.match(extensionRegex);
    return matches && matches[1] ? matches[1] : "";
  }
}
